import { Dispatch, SetStateAction, useEffect, useState, useMemo, MouseEvent } from "react";
import styles from "./CategoryList.module.css";
import commonStyle from "./addPlaceCommon.module.css";
import Icon from "../../../common/Icon";
import { SubContentList } from "./SinglePlaceFormArea";
import { CategoryOptions } from "../../../common/Common";
import { useModal } from "../../../modal/Modal";
import ModalButtons from "../../../modal/ModalButtons";
import BottomButtonBox from "../../BottomButtonBox";

interface CategoryListProps {
    selected: string;
    categories: CategoryOptions[];
    isProUser: boolean;
    setSelectedCategory: (category: string) => void;
    setSubContent: Dispatch<SetStateAction<SubContentList | undefined>>;
}

const CategoryList = ({ ...props }: CategoryListProps) => {
    const [categories, setCategories] = useState<CategoryOptions[]>(props.categories);
    const { ModalComponent, openModal, closeModal } = useModal();

    const MAX_CATEGORY = 16;
    const categoryCount = categories.length;
    const isMaxReached = categoryCount >= MAX_CATEGORY;

    const rightButton = { label: "취소", type: "gray", onClick: () => props.setSubContent(undefined) };

    useEffect(() => {
        categories[0].label === "전체" && setCategories([...categories.slice(1)]);
    }, []);

    useEffect(() => {
        console.log(`[CategoryList] 현재 카테고리 개수: ${categoryCount}`);
    }, [categoryCount]);

    const iconRules = {
        pro: {
            normal:     { add: "add_box",    arrow: "enter_blue", color: "#0088FF" },
            maxReached: { add: "cant_box",   arrow: null,         color: "#808080" }
        },
        free: {
            normal:     { add: "add_box",    arrow: "lock",       color: "#808080" }
        }
    } as const;

    const ruleSet =
        props.isProUser
            ? isMaxReached
                ? iconRules.pro.maxReached
                : iconRules.pro.normal
            : iconRules.free.normal;

    const { add: addIconName, arrow: arrowIconName, color: actionColor } = ruleSet;

    const onCategoryClick = (e: MouseEvent<HTMLDivElement>) => {
        const selected = e.currentTarget.textContent;
        selected && props.setSelectedCategory(selected);
    };

    const onAddButtonClick = () => {
        if (props.isProUser) {
            if(isMaxReached) return;
            props.setSubContent(SubContentList.addCategory);
        } else {
            openModal({
                title: "안내",
                children: "카테고리 추가 기능은 유료 서비스 입니다.",
                modalButtons: (
                    <ModalButtons
                        buttonCount={1}
                        buttons={[{
                            label: "확인",
                            color: "Primary",
                            onClick: () => closeModal(),
                        }]} />
                )
            });
        }
    };

    return (
        <>
            <ModalComponent />
            <div className={`${commonStyle.wrapper} ${styles.wrapper} `}>
                <div className={styles.sub_title}>{"카테고리 선택"}</div>
                {categories.map((category: CategoryOptions, index: number) => {
                    const marker = category.icon ? category.icon : "marker";
                    const color = category.color ? category.color : "grey";

                    return (
                        <div className={`${styles.item} ${commonStyle.pointer}`} key={`category_${index}`} onClick={onCategoryClick}>
                            <Icon name={marker} color={color} />
                            {category.label}
                        </div>
                    );
                })}
                <div
                    // className={`${styles.item} ${!props.isProUser || isMaxReached ? styles.disabled : ""}`}
                    className={`${styles.item} ${isMaxReached ? styles.disabled : ""}`}
                    onClick={onAddButtonClick}>
                    <Icon name={addIconName} color={actionColor} />
                    <div>{!isMaxReached? "카테고리 추가":"카테고리는 16개 이상 추가할 수 없습니다."}</div>
                    {arrowIconName && <Icon name={arrowIconName} color={actionColor} style={{ marginLeft: "auto" }}/>}
                </div>
                <div className={styles.bottom}>
                    <BottomButtonBox right={rightButton} />
                </div>
            </div>
        </>
    );
};

export default CategoryList;
